module.exports = __webpack_public_path__ + "img/pinpaihuodong.82c0d04b.png";